import { useEffect, useState } from 'react';
import userTokenService from '../services/security/userTokenService';
import useIsMountedRef from './useIsMountedRef';

export const useCurrentUser = (project) => {
  const [currentUser, setCurrentUser] = useState();
  const isMountedRef = useIsMountedRef();

  useEffect(() => {
    (async () => {
      if (project.id) {
        const userEmail = await userTokenService.getProjectTokenProperty(
          project.id,
          'email'
        );
        if (isMountedRef.current) {
          setCurrentUser(
            project.users.find(
              (_) => _.email.toLowerCase() === userEmail.toLowerCase()
            )
          );
        }
      }
    })();
  }, [project, isMountedRef]);

  return currentUser;
};
